(() => {
  document.querySelectorAll('[data-editorial-article]').forEach((article) => {
    if (article.dataset.editorialReady) return;
    article.dataset.editorialReady = 'true';
    const body = article.querySelector('[data-article-body]');
    const toc = article.querySelector('[data-article-toc]');
    if (!body) return;
    const headings = [...body.querySelectorAll('h2')];
    const used = new Set([...article.querySelectorAll('[id]')].map((el) => el.id));
    if (toc && headings.length > 1) {
      const list = document.createElement('ol');
      headings.forEach((heading, i) => {
        if (!heading.id) {
          const base = heading.textContent.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || `section-${i + 1}`;
          let id = base;
          let n = 2;
          while (used.has(id)) id = `${base}-${n++}`;
          heading.id = id;
          used.add(id);
        }
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent;
        const item = document.createElement('li');
        item.append(link);
        list.append(item);
      });
      toc.append(list);
      article.querySelector('[data-toc-container]').hidden = false;
      const mobile = window.matchMedia('(max-width: 900px)');
      const adaptToc = () => { article.querySelector('.reading__toc').open = !mobile.matches; };
      adaptToc();
      mobile.addEventListener('change', adaptToc);
      const links = [...list.querySelectorAll('a')];
      let frame = 0;
      let current = -1;
      const markSection = () => {
        frame = 0;
        // Match the theme's anchor offset, including its persistent header.
        const offset = (parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 100) + 24;
        let next = -1;
        headings.forEach((heading, i) => {
          if (heading.getBoundingClientRect().top <= offset) next = i;
        });
        if (current === next) return;
        if (current >= 0) links[current].removeAttribute('aria-current');
        if (next >= 0) links[next].setAttribute('aria-current', 'location');
        current = next;
      };
      const queueSection = () => {
        if (!frame) frame = requestAnimationFrame(markSection);
      };
      window.addEventListener('scroll', queueSection, { passive: true });
      window.addEventListener('resize', queueSection, { passive: true });
      document.fonts?.ready.then(queueSection);
      markSection();
      toc.addEventListener('click', (event) => {
        const link = event.target.closest('a');
        const index = links.indexOf(link);
        if (index < 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const heading = headings[index];
        // Keep native anchor navigation/history, and move keyboard focus with it.
        heading.setAttribute('tabindex', '-1');
        heading.focus({ preventScroll: true });
        if (mobile.matches) article.querySelector('.reading__toc').open = false;
      });
    }
    body.querySelectorAll('table').forEach((table) => {
      const columns = Math.max(1, ...[...table.rows].map((row) => [...row.cells].reduce((sum, cell) => sum + cell.colSpan, 0)));
      table.style.setProperty('--table-columns', Math.min(columns, 12));
      if (table.parentElement.classList.contains('reading__table')) return;
      const wrapper = document.createElement('div');
      wrapper.className = 'reading__table';
      wrapper.tabIndex = 0;
      wrapper.setAttribute('role', 'region');
      wrapper.setAttribute('aria-label', table.caption?.textContent || 'Tableau comparatif, défilement horizontal');
      table.before(wrapper);
      wrapper.append(table);
      const hint = document.createElement('p');
      hint.className = 'reading__table-hint';
      hint.textContent = 'Faites défiler le tableau pour voir la suite.';
      hint.hidden = true;
      wrapper.after(hint);
      const adaptTable = () => {
        // Keep the full caption readable while only the data scrolls on mobile.
        table.style.setProperty('--table-viewport', `${wrapper.clientWidth}px`);
        hint.hidden = wrapper.scrollWidth <= wrapper.clientWidth + 1;
      };
      if ('ResizeObserver' in window) new ResizeObserver(adaptTable).observe(wrapper);
      else window.addEventListener('resize', adaptTable, { passive: true });
      adaptTable();
    });
    article.addEventListener('click', (event) => {
      const link = event.target.closest('a[href]');
      if (!link) return;
      const url = new URL(link.href, location.href);
      if (url.origin !== location.origin) return;
      const type = url.pathname.startsWith('/collections/') ? 'collection' : url.pathname.startsWith('/products/') ? 'product' : null;
      if (!type) return;
      // Local event only: no cookies/network, subscriber must honor analytics consent.
      document.dispatchEvent(new CustomEvent('minouko:editorial-click', { detail: {
        article_id: article.dataset.editorialArticle, destination_type: type,
        destination_path: url.pathname, placement: body.contains(link) ? 'body' : 'related'
      } }));
    });
  });
})();
